import React, { useState } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const SecurityConfigurationPanel = () => {
    const [sessionTimeout, setSessionTimeout] = useState(30); // minutes
    const [mfaEnabled, setMfaEnabled] = useState(false);

    const handleSessionTimeoutChange = (value) => {
        const numValue = parseInt(value);
        if (numValue >= 5 && numValue <= 480) { // 5 minutes to 8 hours
            setSessionTimeout(numValue);
        }
    };

    return (
        <div className="rounded-md flex flex-col gap-3">
            <div className="flex items-center gap-2">
                <Icon icon="tabler:shield-cog" className="text-lg text-primary" />
                <h4 className="font-semibold text-font-primary">Security Configuration</h4>
            </div>

            <div className="flex flex-col gap-2">
                {/* MFA Toggle - Disabled */}
                <div className="card-container flex items-center justify-between py-3 rounded-lg">
                    <div className="flex items-center gap-3">
                        <Icon icon="mdi:two-factor-authentication" className="text-lg text-gray-500" />
                        <div>
                            <div className="font-medium text-font-primary">Enforce MFA</div>
                            <div className="text-sm text-font-secondary">Require multi-factor authentication for all users</div>
                        </div>
                    </div>
                    <div className="relative">
                        <label className="relative inline-flex items-center cursor-not-allowed opacity-50">
                            <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={mfaEnabled}
                                disabled={true}
                            />
                            <div className="w-11 h-6 bg-gray-400 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-md peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-md after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                        </label>
                        <div className="absolute -top-8 left-0 bg-gray-800 text-white text-xs px-2 py-1 rounded-md opacity-0 hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap">
                            This feature is planned for a future release
                        </div>
                    </div>
                </div>

                {/* Admin Session Timeout */}
                <div className="card-container flex items-center justify-between py-3 rounded-lg hover:bg-bgAccent transition-colors">
                    <div className="flex items-center gap-3">
                        <Icon icon="mdi:clock-outline" className="text-lg text-primary" />
                        <div>
                            <div className="font-medium text-font-primary">Admin Session Timeout</div>
                            <div className="text-sm text-font-secondary">Idle timeout for admin sessions (frontend only)</div>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <input
                            type="number"
                            value={sessionTimeout}
                            onChange={(e) => handleSessionTimeoutChange(e.target.value)}
                            className="w-20 px-2 py-1 input-textbox bg-white rounded text-sm text-right border border-bgAccent focus:border-primary focus:outline-none"
                            min="5"
                            max="480"
                        />
                        <span className="text-sm text-font-secondary">minutes</span>
                    </div>
                </div>

                {/* Security Information */}
                <div className="p-3 bg-blue-400 bg-opacity-20 rounded-lg">
                    <div className="flex flex-col items-start gap-2">
                        <div className="flex items-center gap-1">
                            <Icon icon="mdi:information" className="text-blue-500 text-2xl" />
                            <div className="font-bold">Security Note:</div>
                        </div>
                        <div className="text-sm text-font-primary">
                            The admin session timeout is a frontend-only setting that controls when the admin interface 
                            will automatically log out inactive users. This does not affect backend session management.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecurityConfigurationPanel;

